import * as yup from "yup";

import { SSN_REGEX } from "@constants";
import { Translations, i18n } from "@i18n";
import { SsnFormValues } from "./types";

export const validationSchema: yup.SchemaOf<SsnFormValues> = yup.object().shape({
  ssn: yup
    .string()
    .required(i18n.t(Translations.SsnRouteInputRequired))
    .matches(SSN_REGEX, i18n.t(Translations.SsnRouteInputInvalid)),
});
